export default {
    userInfo: state => state.userInfo,
    applyMeunList: state => state.applyMeunList,
    pageTagsData: state => state.pageTagsData,
    message: state => state.message,
    taskType: state => state.taskType,
    webName: state => state.webName,
    projectName: state => state.projectName
};
